import { createContext } from "react";
import { createTRPCReact } from "@trpc/react-query";
import type { PlatformRouter } from "@amsaas/api";

/**
 * Typed tRPC React client for the PLATFORM path (ENH-007), mounted at
 * /trpc/platform on the API. Separate from the tenant client (`trpc`) so a
 * platform user's org-less session never hits tenant-scoped procedures and the
 * two type surfaces stay distinct. Type-only import — no server code in bundle.
 *
 * CRITICAL: this MUST be given its own React context. Every `createTRPCReact()`
 * that omits `context` falls back to a single module-level default context
 * (@trpc/react-query: `const Context = config?.context ?? TRPCContext`). With the
 * default shared, nesting <platformTrpc.Provider> inside <trpc.Provider> makes
 * this platform client overwrite the tenant client for ALL hooks below — so
 * `trpc.auth.me` would be sent to /trpc/platform and 404. A dedicated context
 * keeps the two clients isolated.
 */
export const platformTrpc = createTRPCReact<PlatformRouter>({
  context: createContext(null),
});
